export default "__VITE_ASSET__6c7749a3__"